/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SalesAggregate
 */
export interface SalesAggregate {
    /**
     * 
     * @type {string}
     * @memberof SalesAggregate
     */
    contentType: string;
    /**
     * 
     * @type {string}
     * @memberof SalesAggregate
     */
    contentId: string;
    /**
     * 
     * @type {number}
     * @memberof SalesAggregate
     */
    purchaseCount: number;
}

/**
 * Check if a given object implements the SalesAggregate interface.
 */
export function instanceOfSalesAggregate(value: object): value is SalesAggregate {
    let isInstance = true;
    isInstance = isInstance && "contentType" in value && value["contentType"] !== undefined;
    isInstance = isInstance && "contentId" in value && value["contentId"] !== undefined;
    isInstance = isInstance && "purchaseCount" in value && value["purchaseCount"] !== undefined;

    return isInstance;
}

export function SalesAggregateFromJSON(json: any): SalesAggregate {
    return SalesAggregateFromJSONTyped(json, false);
}

export function SalesAggregateFromJSONTyped(json: any, ignoreDiscriminator: boolean): SalesAggregate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'contentType': json['content_type'],
        'contentId': json['content_id'],
        'purchaseCount': json['purchase_count'],
    };
}

export function SalesAggregateToJSON(value?: SalesAggregate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'content_type': value.contentType,
        'content_id': value.contentId,
        'purchase_count': value.purchaseCount,
    };
}

